import { AxiosInstance } from 'axios';

import { useEffect } from 'react';
import { useState } from 'react';

import { GlobalSignIn } from '../ems-core/css/Global.styles';
import { signin, requestNewPassword } from '../ems-core/scripts/api';
import { SafeUser } from '../ems-core/scripts/api/types';
import { useLocalStorage } from '../ems-core/scripts/hooks/localStorageHook';
import { SLoginStatusProps } from '../ems-core/specific/SLoginStatus';
import { ViewLogin } from '../ems-core/views/Login';
import { jwtDecode } from 'jwt-decode';

export type Feedback = SLoginStatusProps['status'] | undefined;
type Props = {
  /**
   * Axios api instance
   */
  api: AxiosInstance;
  /**
   * Feedback set by the parent component to signal external events
   */
  feedback: Feedback;
  /**
   * Setup the token to a given value and change the api instance to have
   * the new current token.
   */
  setToken: (token: string) => void;
  /**
   * Setup User info in signIn.
   */
  setUser: (user: SafeUser) => void;
};

/**
 * Signin
 */
const Page = ({ api, setToken, feedback, setUser }: Props) => {
  const [defaultEmail, setDefaultEmail] = useLocalStorage('bess-email', '');
  const [status, setStatus] = useState<Feedback>(feedback);

  useEffect(() => setStatus(feedback), [feedback]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      try {
        const decoded = jwtDecode<SafeUser & { exp?: number }>(token);
        setToken(token);
        setUser(decoded);
      } catch (err) {
        console.error('Token inválido:', err);
        setStatus('wrong');
      }
    }
  }, []);
  //
  return (
    <>
      <GlobalSignIn />
      <ViewLogin
        status={status}
        defaultEmail={defaultEmail}
        onRecoverPassword={(mail) => {
          setStatus('operation');
          if (mail != '') {
            requestNewPassword(api, mail)
              .then(() => setStatus('checkMail'))
              .catch((error) => {
                console.log(error.response);
                if (error.response.data.errors.find((el: any) => el.param == 'email')) {
                  setStatus('invalidEmailError');
                } else setStatus('sendingEmailError');
              });
          } else {
            setStatus('nonEmptyEmail');
          }
        }}
        onLogin={(email: string, password: string, remember: boolean) => {
          setStatus('checking');

          if (email.length === 0 || password.length === 0) {
            setStatus('empty');
            return;
          }

          signin(api, email, password)
            .then((data) => {
              if (remember) setDefaultEmail(email);
              setToken(data.token);
              setUser(data);
            })
            .catch(() => {
              setStatus('wrong');
            });
        }}
      />
    </>
  );
};
export default Page;
